import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class WebhookActivityEventQueryCriteriaClass extends BaseCriteriaModel {
    //header, bl_webhook_activity_event table
    guid?: Optional<string> = Optional.empty();
    subscription_hdr_guid?: Optional<string> = Optional.empty();
    sent_body?: Optional<string> = Optional.empty();
    received_body?: Optional<string> = Optional.empty();
    created_date?: Optional<string> = Optional.empty();
    received_http_code?: Optional<string> = Optional.empty();
}

export class WebhookActivityEventCriteriaModelQuery {
  query = '';

  constructor(WebhookActivityEventCriteriaModel: WebhookActivityEventQueryCriteriaClass) {

    if (!WebhookActivityEventCriteriaModel) {
      return;
    }

    this.query += WebhookActivityEventCriteriaModel.guid.filter(x => x !== '').map(x => '&guid=' + x).orElse('');
    this.query += WebhookActivityEventCriteriaModel.subscription_hdr_guid.filter(x => x !== '').map(x => '&subscription_hdr_guid=' + x).orElse('');
    this.query += WebhookActivityEventCriteriaModel.sent_body.filter(x => x !== '').map(x => '&sent_body=' + x).orElse('');
    this.query += WebhookActivityEventCriteriaModel.received_body.filter(x => x !== '').map(x => '&received_body=' + x).orElse('');
    this.query += WebhookActivityEventCriteriaModel.created_date.filter(x => x !== '').map(x => '&created_date=' + x).orElse('');
    this.query += WebhookActivityEventCriteriaModel.received_http_code.filter(x => x !== '').map(x => '&received_http_code=' + x).orElse('');

    this.query += '&status=' + WebhookActivityEventCriteriaModel.status;
    this.query += '&orderBy=' + WebhookActivityEventCriteriaModel.orderBy;
    this.query += '&order=' + WebhookActivityEventCriteriaModel.order;
    this.query += '&offset=' + WebhookActivityEventCriteriaModel.offset + '&limit=' + WebhookActivityEventCriteriaModel.limit;
  }
}
